var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCompliance(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 0,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-icons",
    transform: "translate(-19.000000, -497.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(19.000000, 497.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,1 L14,1 L14,12 L15,12 L15,1 C15,0.45 14.55,0 14,0 L1,0 C0.45,0 0,0.45 0,1 L0,17 C0,17.55 0.45,18 1,18 L9.98,18 L9.98,17 L1,17 L1,1 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    points: "3 4 7 4 7 3 3 3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    points: "3 7 12 7 12 6 3 6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    points: "3 10 12 10 12 9 3 9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    points: "3 13.027 12 13.027 12 12.027 3 12.027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.222,12.371 L14.9545515,14.9842955 L13.4843,16.6788 L11.6783,15.0308 L11.0043,15.7688 L11.3733,16.1058 L13.2033,17.7748 C13.3043,17.8678 13.4403,17.9148 13.5773,17.9048 C13.7143,17.8938 13.8423,17.8268 13.9293,17.7198 L18,13 L17.222,12.371 Z",
    id: "Fill-8"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompliance);
export default __webpack_public_path__ + "static/media/compliance.230d1909.svg";
export { ForwardRef as ReactComponent };